import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useMemo } from 'react';
import type { ProductMinimal } from '@travelity/api';
import { getScheduleRecurrenceLabel } from '../../../../helpers';
import { StartTimeField } from './components/StartTimeField';

export type UnitProductsTableProps = {
    dayIndex: number;
    products: Array<ProductMinimal & { start_time?: string }>;
    onRemove: (productId: string) => void;
};

const UnitProductsTable = ({
    dayIndex,
    products,
    onRemove,
}: UnitProductsTableProps) => {
    const columns = useMemo(
        () => ['Product', 'Schedule', 'Duration', 'Start time', ''],
        []
    );

    return (
        <TableContainer sx={{ backgroundColor: 'background.paper' }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        {columns.map(column => (
                            <TableCell key={column} sx={{ fontWeight: 700 }}>
                                {column}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {products.map((product, productIndex) => {
                        const resolvedSchedule = product.resolvedSchedules?.[0];
                        const scheduleLabel = resolvedSchedule
                            ? getScheduleRecurrenceLabel(
                                  resolvedSchedule.recurrence,
                                  resolvedSchedule.dates
                              )
                            : 'No schedules';
                        const durationHours = `${product.schedule?.[0]?.duration?.estimated?.hours}.${product.schedule?.[0]?.duration?.estimated?.minutes}h`;

                        return (
                            <TableRow
                                key={product.id}
                                hover
                                sx={{ border: 'none' }}
                            >
                                <TableCell>
                                    <Typography fontWeight={600}>
                                        {product.name}
                                    </Typography>
                                    <Typography
                                        sx={{ textTransform: 'capitalize' }}
                                        variant="body2"
                                    >
                                        {product.type}
                                    </Typography>
                                </TableCell>
                                <TableCell>{scheduleLabel}</TableCell>
                                <TableCell>{durationHours}</TableCell>
                                <TableCell>
                                    <StartTimeField
                                        dayIndex={dayIndex}
                                        productIndex={productIndex}
                                        product={product}
                                        scheduleInput={{
                                            any_time:
                                                resolvedSchedule?.any_time,
                                            start_times:
                                                resolvedSchedule?.start_times,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={{ textAlign: 'end' }}>
                                    <IconButton
                                        sx={{
                                            color: 'error.main',
                                        }}
                                        aria-label="remove"
                                        onClick={() => onRemove(product.id)}
                                    >
                                        <DeleteOutlineIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default UnitProductsTable;
